// src/utils/authStorage.js
// Auth is now handled by the backend using an HttpOnly cookie.
// JavaScript cannot read that JWT cookie, so this file only manages non-sensitive UI flow values.

const AUX_KEYS = ["selectedPlan", "passwordResetEmail"];
const PENDING_VERIFICATION_EMAIL_KEY = "pendingVerificationEmail";

export function setAuthToken() {
  // No-op. Kept so older imports do not break during the HttpOnly-cookie migration.
}

export function getAuthToken() {
  // The JWT is in an HttpOnly cookie, so JavaScript cannot read it.
  return null;
}

export function isLoggedIn() {
  // Check auth by calling /site/user/logged-user instead.
  return false;
}

export function clearAuth() {
  for (const key of AUX_KEYS) {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  }
}

export function setSelectedPlan(planKey, { persist = false } = {}) {
  const key = "selectedPlan";

  if (!planKey) {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
    return;
  }

  sessionStorage.removeItem(key);
  localStorage.removeItem(key);

  const store = persist ? localStorage : sessionStorage;
  store.setItem(key, String(planKey));
}

export function getSelectedPlan() {
  return sessionStorage.getItem("selectedPlan") || localStorage.getItem("selectedPlan") || null;
}

export function setPendingVerificationEmail(email) {
  const normalized = String(email || "").trim().toLowerCase();

  if (!normalized) {
    localStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
    return;
  }

  localStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, normalized);
}

export function getPendingVerificationEmail() {
  return localStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY) || null;
}

export function clearPendingVerificationEmail() {
  localStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
}

export function setPasswordResetEmail(email) {
  const trimmed = String(email || "").trim().toLowerCase();

  if (!trimmed) {
    sessionStorage.removeItem("passwordResetEmail");
    return;
  }

  sessionStorage.setItem("passwordResetEmail", trimmed);
}

export function getPasswordResetEmail() {
  return sessionStorage.getItem("passwordResetEmail") || null;
}
